import { testimonials } from '@/mocks/skincare';

export default function Reputation() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100/70">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            用户口碑
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            听听她们怎么说——来自真实用户的护肤故事
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-background-50 rounded-lg p-6 border border-background-200/70">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, starIndex) => (
                  <i
                    key={starIndex}
                    className={`ri-star-fill text-sm ${starIndex < t.rating ? 'text-secondary-500' : 'text-background-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center text-accent-700 text-sm font-medium">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.age}岁 · {t.skinType}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}